module.exports = __webpack_public_path__ + "img/FA4.d2309488.png";